"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateKeyValuePair = void 0;
const faker_1 = __importDefault(require("@faker-js/faker"));
function generateKeyValuePair(isString = false) {
    const key = faker_1.default.unique(() => faker_1.default.datatype.number({ max: 1000, min: 1 }));
    const value = faker_1.default.datatype.number({ max: 1000, min: 1 });
    if (isString) {
        return { key: key.toString(), value: value.toString() };
    }
    return { key, value };
}
exports.generateKeyValuePair = generateKeyValuePair;
